import React, { Component } from 'react';

import { USER_ROLE_ANONYMOUS } from 'common/userRoles';
import { SCREEN_ID_HOMEPAGE } from 'client/constants/screenIds';
import { URL_IABS } from 'client/constants/urls';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedRoles from 'client/helpers/allowedRoles';

import SrLink from 'client/components/SrLink/SrLink';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';

@withTransitionHook
@allowedRoles({
  roles: [
    USER_ROLE_ANONYMOUS,
  ],
  redirectUrl: '/feed',
})
@withScreenId(SCREEN_ID_HOMEPAGE)
@withScrollToTop
class HomePage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Renting homes, made simple',
    section: 'Home',
    keywords: 'rent, home, austin, tour, apartment',
    description: (
      'Sunroom rents single family homes across the country and provides' +
      'leasing products and services for your entire portfolio. ' +
      'For property managers and real estate investors focused on growing their portfolio.'
    ),
    image: 'https://sunroomrentals.com/images/metadata/og-house.jpg',
  })

  render() {
    return (
      <div className='page-landing'>
        <div id='navbar'>
          <SrFlex justify='between' align='center'>
            <SrLink to='/' className='logo' />
            <SrFlex direction='row' justify='center' align='center'>
              <SrLink to='/login' id='login'>
                <SrText>
                  Log In
                </SrText>
              </SrLink>
              <SrLink to='/get-started'>
                <div className='signup-button'>
                  sign up
                </div>
              </SrLink>
            </SrFlex>
          </SrFlex>
        </div>

        <div className='hero'>
          <div className='column-left'>
            <h1>Renting homes, made simple</h1>
            <h2>Lease properties across the country</h2>
            <SrLink
              to='/start'
              className='button yellow cta'
            >
              search rentals →
            </SrLink>
            <SrLink
              to='https://sunroomleasing.com'
              target='_blank'
              className='button blue cta secondary'
            >
              manager & reits →
            </SrLink>
          </div>
          <div className='column-right'>
            <span className='hero-image' />
          </div>
        </div>

        <div className='section tagline'>

          <div className='section nativeApp'>
            <span className='headline'>Download our free app!</span>
            <div className='flexContainer'>
              <a
                href='https://itunes.apple.com/us/app/sunroom-rentals/id1445221096'
                target='_blank'
                rel='noopener noreferrer'
              >
                <span className='app ios' />
              </a>
              <a
                href='https://play.google.com/store/apps/details?id=com.mobile.sunroomrentals'
                target='_blank'
                rel='noopener noreferrer'
              >
                <span className='app android' />
              </a>
            </div>
          </div>
        </div>

        <div className='footer'>
          <span>Made with <span className='color-red'>❤</span> in Austin, TX.</span>
          <br />
          <span>
            Want to work with us? Apply on our
            <SrLink to='https://sunroom.recruitee.com/' target='_blank'> careers page</SrLink>
            .
          </span>
          <br />
          <br />
          <br />
          <div>
            <SrFlex justify='center' align='center' wrap='wrap'>
              <SrLink
                to='https://sunroomleasing.com/'
                target='_blank'
              >
                Sunroom Leasing
              </SrLink>
              <SrBox margin='0 6px'>
                <SrText>|</SrText>
              </SrBox>
              <SrLink
                to='https://sunroomleasing.com/about-sunroom'
                target='_blank'
              >
                About Sunroom
              </SrLink>
            </SrFlex>
          </div>
          <div>
            <SrFlex justify='center' align='center' wrap='wrap'>
              <SrLink
                to={URL_IABS}
                target='_blank'
              >
                IABS
              </SrLink>
              <SrBox margin='0 6px'>
                <SrText>|</SrText>
              </SrBox>
              <SrLink
                to='https://www.trec.texas.gov/forms/consumer-protection-notice'
                target='_blank'
              >
                TREC Consumer Protection
              </SrLink>
            </SrFlex>
          </div>
        </div>
      </div>
    );
  }
}

HomePage.displayName = 'HomePage';

export default HomePage;
